import { render } from "./recargas.vue?vue&type=template&id=a5127ae6&scoped=true"
import script from "./recargas.vue?vue&type=script&lang=js"
export * from "./recargas.vue?vue&type=script&lang=js"

import "./recargas.vue?vue&type=style&index=0&id=a5127ae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5127ae6"]])

export default __exports__